"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = exports.config = void 0;
const axios_1 = __importDefault(require("axios"));
const fs = __importStar(require("fs"));
const eosjs_1 = require("eosjs");
const eosjs_jssig_1 = __importDefault(require("eosjs/dist/eosjs-jssig"));
const fetch = require("isomorphic-fetch");
const { TextEncoder, TextDecoder } = require("util");
/**
 * Settings
 *
 * @private
 */
class Settings {
    constructor() {
        this.token = "";
        this.private_key = "";
        this.endpoint = "https://graph-api.eosdetective.io/v0/";
        this.endpoint_eosio = "https://api.eosn.io";
        this.actor = "";
        this.permission = "";
        this.contract = "";
    }
    get signatureProvider() {
        if (!this.private_key) {
            throw new Error("[private_key] is required");
        }
        return new eosjs_jssig_1.default([this.private_key]);
    }
    get rpc() {
        if (!this.endpoint_eosio) {
            throw new Error("[endpoint_eosio] is required");
        }
        return new eosjs_1.JsonRpc(this.endpoint_eosio, { fetch });
    }
    get api() {
        const rpc = this.rpc;
        const signatureProvider = this.signatureProvider;
        return new eosjs_1.Api({ rpc, signatureProvider, textDecoder: new TextDecoder(), textEncoder: new TextEncoder() });
    }
    get authorization() {
        if (!this.actor) {
            throw new Error("[actor] is required");
        }
        if (!this.permission) {
            throw new Error("[permission] is required");
        }
        return [{
                actor: this.actor,
                permission: this.permission
            }];
    }
}
function config(token, options = {}) {
    if (!token) {
        throw new Error("[token] is required");
    }
    // Read environment variables if `token` = `.env`
    if (token.includes(".env")) {
        if (!fs.existsSync(token)) {
            throw new Error("[token] .env filepath does not exist");
        }
        require('dotenv').config(token);
        exports.settings.token = process.env.DETECTIVE_TOKEN || exports.settings.token;
        exports.settings.contract = process.env.DETECTIVE_CONTRACT || exports.settings.contract;
        exports.settings.endpoint = process.env.DETECTIVE_ENDPOINT || exports.settings.endpoint;
        exports.settings.actor = process.env.ACTOR || exports.settings.actor;
        exports.settings.private_key = process.env.PRIVATE_KEY || exports.settings.private_key;
        exports.settings.permission = process.env.PERMISSION || exports.settings.permission;
        exports.settings.endpoint_eosio = process.env.ENDPOINT_EOSIO || exports.settings.endpoint_eosio;
    }
    else {
        exports.settings.token = token;
    }
    // Optional Detective params
    exports.settings.token = options.token || exports.settings.token;
    exports.settings.endpoint = options.endpoint || exports.settings.endpoint;
    exports.settings.contract = options.contract || exports.settings.contract;
    // Optional EOSIO params
    exports.settings.endpoint_eosio = options.endpoint_eosio || exports.settings.endpoint_eosio;
    exports.settings.private_key = options.private_key || exports.settings.private_key;
    exports.settings.actor = options.actor || exports.settings.actor;
    exports.settings.permission = options.permission || exports.settings.permission;
    // Set globals
    axios_1.default.defaults.baseURL = exports.settings.endpoint;
    axios_1.default.defaults.headers.common["X-Api-Key"] = exports.settings.token;
    axios_1.default.defaults.headers.common.Authorization = `Bearer ${exports.settings.token}`;
    if (!exports.settings.token) {
        throw new Error("[settings.token] is required");
    }
}
exports.config = config;
exports.settings = new Settings();
//# sourceMappingURL=config.js.map